import { useState } from 'react';

const faqItems = [
  {
    q: '8848影院的电影需要付费观看吗？',
    a: '完全不需要。8848影院所有电影均为免费在线观看，无需注册账号，无需购买会员，打开网页即可畅享高清影院大片，即点即播。',
  },
  {
    q: '电影画质怎么样？支持高清播放吗？',
    a: '我们提供从标清到1080P全高清的多档画质选择，大部分影片支持超清画质。系统会根据你的网络状况自动匹配最佳清晰度，确保流畅观影。',
  },
  {
    q: '手机上可以观看吗？需要下载APP吗？',
    a: '8848影院完美适配手机、平板和电脑端，使用浏览器即可访问。我们也提供移动端专属入口，体验更加沉浸的掌上观影。无需下载任何软件。',
  },
  {
    q: '片源更新快吗？多久能看新上映的电影？',
    a: '我们的片库每日更新，紧跟全球电影发行节奏。热门大片下映后会尽快上线，同时经典电影和冷门佳片也在持续扩充，确保片库新鲜丰富。',
  },
  {
    q: '支持哪些电影类型？有分类筛选吗？',
    a: '8848影院涵盖动作片、喜剧片、爱情片、科幻片、恐怖片、动画片、纪录片等十余个大类，支持按类型、年份、评分、地区等多维度筛选，快速找到你想看的电影。',
  },
  {
    q: '观影时需要安装什么播放器或插件吗？',
    a: '无需安装任何播放器或插件。8848影院采用先进的在线播放技术，在浏览器中直接播放，兼容Chrome、Safari、Edge等主流浏览器，打开即看。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-300 bg-accent-500/10 rounded-full mb-4">
            常见问题
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-50 mb-3">
            观影常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-[560px] mx-auto">
            关于8848影院的使用方式、片源质量和播放体验，这里有你想要的答案
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-200/80 border border-background-300/50 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer hover:bg-background-300/30 transition-colors"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-200 pr-4">{item.q}</h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-foreground-400 text-lg"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openIndex === idx ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 md:px-6 pb-4 md:pb-5 text-sm text-foreground-400 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}